import { connect } from "react-redux";
import PMDashboard from "./pmDashboard";
import { bindActionCreators } from "redux";
import {
  fetchPmDashboard,fetchSitesAndGates
  // getPmSitiesFilterDropDown,
} from "services/redux/maintenance/pmDashboard/action";
import {materialInspected} from 'services/redux/ToolkitInspection/action'
import { getProfile } from 'services/redux/auth/login/action';

const mapStateToProps = (state) => ({
  pmDashboardData: state.pmDashboardReducer.pmDashboardData,
  maintenanceMonth: state.pmSitiesReducer.maintenanceMonth,
  downloadPmList: state.pmSitiesReducer.downloadPmList,
  pmdropdownList: state.pmSitiesReducer.pmdropdownList,
  userProfile : state.loginReducer.userProfile,
  sitesAndGatesData: state.pmDashboardReducer.instSitesAndGates,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmDashboard,
      fetchSitesAndGates,
      // getPmSitiesFilterDropDown,
      materialInspected,
      getProfile
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PMDashboard);
